import { AxiosResponse } from 'axios';
import { api } from 'hooks/useApi';
import { FilterViewEnum } from 'types/FilterProjects';

type CsvExportResponse = {
  url: string;
};

type ProjectCsvExportParams = {
  groupConfigId: string;
  company?: string;
  companyId?: string;
  activeTabs?: FilterViewEnum[];
};

const postProjectCsvExport = ({
  groupConfigId,
  company,
  companyId,
  activeTabs,
}: ProjectCsvExportParams): Promise<AxiosResponse<CsvExportResponse | null>> => {
  let url = `/projects/export-csv/?group_config_id=${groupConfigId}`;
  if (company) url += `&company=${company}`;
  if (companyId && Number(companyId) !== 0) url += `&company_id=${companyId}`;

  return api.post(url, {
    include_starred_projects: activeTabs?.includes(FilterViewEnum.STAR),
    include_watching_projects: activeTabs?.includes(FilterViewEnum.WATCH),
    include_no_status_projects: activeTabs?.includes(FilterViewEnum.NO_STATUS),
    include_hidden_projects: activeTabs?.includes(FilterViewEnum.HIDDEN),
  });
};

const getCompanyCsvExport = (
  groupConfigId: string,
): Promise<AxiosResponse<CsvExportResponse | null>> => {
  return api.get(`/group-configuration/${groupConfigId}/export-company-csv/`);
};

type CollectionCsvExportParams = {
  collectionId: number;
  selectedFilterCategories?: FilterViewEnum[];
};

const postCollectionCsvExport = ({
  collectionId,
  selectedFilterCategories,
}: CollectionCsvExportParams): Promise<AxiosResponse<CsvExportResponse | null>> => {
  return api.post(`/collections/export-csv/?collection_id=${collectionId}`, {
    include_starred_projects: selectedFilterCategories?.includes(FilterViewEnum.STAR),
    include_watching_projects: selectedFilterCategories?.includes(FilterViewEnum.WATCH),
  });
};

export default {
  postProjectCsvExport,
  getCompanyCsvExport,
  postCollectionCsvExport,
};
